<shared-navigation-top [title]="title"></shared-navigation-top>

<div class="content animation-fade-in">
    <div class="heading">
        <p>We work hard to take the greatest care of items entrusted to us, and will sometimes need your authorisations in order to proceed with your order.</p>
    </div>

    <user-authorisations-form-mobile [isInBookingProcess]="false"></user-authorisations-form-mobile>
</div>